<template>
  <div class="Modals">

    <modal name="modal-videoCalls" height="auto" :scrollable="true">
      <div class="padding">

        <h1>Video calls</h1>

        <p>
          What type of video call is being used?
        </p>

        <hr />

        <h2>Video call in browser</h2>

        <p class="gray">
          Stream Textify captions to popular browser video conference calls, such as <a href="https://meet.jit.si/" target="_blank">Jitsi</a>, <a href="https://zoom.us/" target="_blank">Zoom</a> and <a href="https://meet.google.com/" target="_blank">Google Meet</a>.
        </p>

        <ol>
          <li>
            Install the <a href="https://chrome.google.com/webstore/detail/textify/bmgeoickdkceegcemaohalboegigahbg" target="_blank">Textify web extension for Chrome</a>.
          </li>
          <li>
            Choose which browser window should display the captions as an overlay.
          </li>
        </ol>

        <ExtensionSettings></ExtensionSettings>

        <hr />

        <h2>Zoom desktop meeting</h2>
        <p class="gray">
          Stream Textify captions to video conference calls in Zoom desktop app for Windows and MacOS.
        </p>

        <ol>
          <li>
            Enable closed captions in your Zoom account, <a href="https://support.zoom.us/hc/en-us/articles/207279736" target="_blank">read instructions</a>.
          </li>
          <li>
            The host or co-host of the Zoom meeting obtains the Zoom API token, <a href="https://support.zoom.us/hc/en-us/articles/115002212983#h_4b01d271-eb7b-473d-b82a-f8bb6eb80ba1" target="_blank">read instructions</a>.
          </li>
          <li>
            Paste the token in the field below.
          </li>
          <li>
            In a short while, you should see the caption <i>{{zoom.connectedMessage}}</i> in your Zoom video call.
          </li>
        </ol>
        <ZoomSettings></ZoomSettings>

        <hr />

        <div class="center">
          <button @click="hide('modal-videoCalls')">Close</button>
        </div>

      </div>
    </modal>

    <modal name="modal-stream" height="auto" :scrollable="true">
      <div class="padding">

        <h1>Live stream</h1>

        <p>
          How do you want to display the captions?
        </p>

        <hr />

        <h2>As browser overlay</h2>
        <p class="gray">
          Stream Textify captions for your live audio & video streams and display as an overlay of your own web content.
        </p>

        <ol>
          <li>
            Install the <a href="https://chrome.google.com/webstore/detail/textify/bmgeoickdkceegcemaohalboegigahbg" target="_blank">Textify web extension for Chrome</a>.
          </li>
          <li>
            Choose which browser window should display the captions as an overlay.
          </li>
        </ol>

        <ExtensionSettings></ExtensionSettings>

        <hr />

        <h2>In a video streaming software</h2>
        <p class="gray">
          Stream Textify captions using window capture in popular streaming software, such as <a href="https://obsproject.com/" target="_blank">OBS Studio</a> or <a href="https://streamlabs.com/streamlabs-obs" target="_blank">Streamlabs</a>. Features may vary between different software.
        </p>

        <h3>Using window capture</h3>
        <ol>
          <li>
            Open your streaming software's window capture tool and select the Textify browser window
          </li>
          <li>
            Crop the window capture to a suitable size
          </li>
          <li>
            Adjust the Textify transcript font size and colors
          </li>
        </ol>

        <h3>Using browser source</h3>
        <ol>
          <li>
            Start a Textify room: <a href="https://textify.cc/room/your-room-name" target="_blank">https://textify.cc/room/your-room-name</a>.
          </li>
          <li>
            Open your streaming software's browser capture tool and enter the room url and add <strong>?mode=captions</strong>: <a href="https://textify.cc/room/your-room-name?mode=captions" target="_blank">https://textify.cc/room/your-room-name?mode=captions</a>
          </li>
          <li>
            Crop the browser capture to a suitable size
          </li>
        </ol>

        <hr />
        <div class="center">
          <button @click="hide('modal-stream')">Close</button>
        </div>


      </div>
    </modal>

  </div>
</template>

<script>

import { mapState } from 'vuex'

import ExtensionSettings from '@/components/ExtensionSettings.vue'
import ZoomSettings from '@/components/ZoomSettings.vue'

export default {
  name: 'Modals',
  components: {
    ExtensionSettings,
    ZoomSettings
  },
  computed: {
    ...mapState('apis',[
      'zoom'
    ]),
  },
  methods: {
    hide: function(name){
      this.$modal.hide(name);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.Modals{
}

</style>
